import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { City } from './city.interface';
import cityService from './city.service';

export interface CityState {
   city: Array<City>;
}

const CityStore: Module<CityState, StoreState> = {
   namespaced: true,
   state: {
      city: [],
   },

   getters: {},

   mutations: {
      SET_CITY(state, city) {
         state.city = city;
      },
   },

   actions: {
      async get(context, { filter_name, set_as_state = true }: { filter_name: string; set_as_state: boolean }) {
         return await cityService.get(filter_name).then((response) => {
            if (!response) return;

            if (set_as_state) context.commit('SET_CITY', response.data);
            return response;
         });
      },
   },
};

export default CityStore;
